import { Alert, AlertType } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { appPaths } from '~/routes/app-paths';
import { useLanguageStore } from '~/stores/use-language-store/useLanguageStore';
import { ToastPosition, useToasts } from '~/stores/use-toasts/useToasts';

export const useLanguageChangeToast = () => {
  const toastId = 'language-change-success';
  const { showToast, removeToast } = useToasts();
  const { t } = useTranslation(['settings']);
  const navigate = useNavigate();

  const showLanguageChangeToast = () => {
    const languageOption = useLanguageStore.getState().languageSetting;
    const languageOptionTitle = t(
      `settings:account.languageOptions.${languageOption}`
    );
    showToast({
      id: toastId,
      position: ToastPosition.TopRight,
      timeout: 4000,
      content: (
        <Alert
          title={t('settings:account.languageSetTo', {
            language: languageOptionTitle,
          })}
          message={t('settings:account.youCanChangeInSettings')}
          type={AlertType.Success}
          primaryBtn={{
            label: t('settings:account.openSettings'),
            onClick: () => {
              navigate(appPaths.settings.account);
              removeToast(toastId);
            },
          }}
          onClose={() => removeToast(toastId)}
        />
      ),
    });
  };

  return {
    showLanguageChangeToast,
  };
};
